// 项目搭建需要用的方法

import MD5 from 'md5'
// const { VUE_APP_APPSECRET: APPSECRET, } = process.env
const FROM_SAAS = window.location.pathname === '/saasLogin' // 是否为saas登录
const APPSECRET = process.env[FROM_SAAS ? 'VUE_APP_APPSECRET_SAAS' : 'VUE_APP_APPSECRET' ]

/**
 * 模拟 sort 排序 (解决 Safari 下 soft 的 BUG)
 * @param  {Array}   array 需要排序的数组
 * @param  {Function} fn   排序函数
 * @return {Array}         返回排序后的数组
 */
export const _sort = (array, fn) => {
  for (var i = 0; i < array.length - 1; i++) {
    var isSorted = true
    for (var j = 0; j < array.length - 1 - i; j++) {
      if (fn(array[j], array[j + 1]) > 0) {
        var temp = array[j]
        array[j] = array[j + 1]
        array[j + 1] = temp
        isSorted = false
      }
    }
    if (isSorted) {
      return false
    }
  }
}

export const __objSort = res => {
  var str = []
  // var obj = {}
  // 将对象转成数组
  for (var i in res) {
    str.push([i, res[i]])
  }
  // 对数组进行排序
  _sort(str, function (a, b) {
    return a[0] > b[0]
  })
  // 然后转成对象
  // for (let i = 0; i < str.length; i++) {
  //   obj[str[i][0]] = str[i][1]
  // }
  return str
}

export const __joinObj = res => {
  let objs = __objSort(res)
  let strs = ''
  for (let i = 0; i < objs.length; i++) {
    strs += objs[i][0] + '' + ((objs[i][1] === null || objs[i][1] === undefined) ? '' : objs[i][1])
  }
  strs = MD5(APPSECRET + strs + APPSECRET).toLowerCase()
  return strs
}

// 设置窗口title
export const setPageTitle = (title) => {
  return title ? `商户-${title}` : '商户'
}